import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

// Reálná obálka e-booku v elegantním 3D rámu.
// Grafika obálky se nijak nemění – jde o původní dodaný soubor.

export const BookMockup = ({ className = "" }) => {
  const ref = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const rotateX = useSpring(useTransform(my, [0, 1], [7, -7]), { stiffness: 140, damping: 16 });
  const rotateY = useSpring(useTransform(mx, [0, 1], [-9, 9]), { stiffness: 140, damping: 16 });

  const onMove = (e) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    mx.set((e.clientX - rect.left) / rect.width);
    my.set((e.clientY - rect.top) / rect.height);
  };

  const reset = () => {
    mx.set(0.5);
    my.set(0.5);
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={reset}
      className={`[perspective:1400px] ${className}`}
      data-testid="book-mockup"
    >
      <motion.div
        style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
        className="relative mx-auto w-56 sm:w-64 lg:w-80"
      >
        {/* zadní desky + hrana stránek (2D hloubka) */}
        <div
          aria-hidden="true"
          className="absolute inset-y-[6px] -right-[10px] w-[10px] rounded-r-[2px] bg-gradient-to-b from-[#efe8da] via-[#d9d0bc] to-[#b9ae95]"
          style={{ transform: "translateZ(-6px)" }}
        />
        <div
          aria-hidden="true"
          className="absolute inset-0 -left-[10px] rounded-l-sm bg-gradient-to-b from-[#242c37] via-[#151b23] to-[#0c1015]"
          style={{ transform: "translateZ(-12px)" }}
        />
        {/* přední obálka – původní grafika */}
        <img
          src="/assets/ebook-cover.webp"
          width={1087}
          height={1536}
          alt="Obálka e-booku 40 principů lepšího muže – Proměna muže"
          className="relative block w-full rounded-r-[3px] shadow-[0_40px_90px_-20px_rgba(0,0,0,0.75)]"
          style={{ transform: "translateZ(1px)" }}
          fetchpriority="high"
        />
        {/* jemný odlesk */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 rounded-r-[3px] bg-gradient-to-br from-white/[0.07] via-transparent to-black/20"
          style={{ transform: "translateZ(2px)" }}
        />
      </motion.div>
    </div>
  );
};
